import React from "react";

function GalleryIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      fill="none"
      viewBox="0 0 19 18"
    >
      <path
        fill="currentColor"
        d="M6.418 8.25a1.125 1.125 0 100-2.25 1.125 1.125 0 000 2.25zM8.668 10.5L7.543 9l-2.25 3h9l-3.375-4.5-2.25 3z"
      ></path>
      <path
        fill="currentColor"
        d="M15.793 3h-12c-.827 0-1.5.673-1.5 1.5v9c0 .827.673 1.5 1.5 1.5h12c.827 0 1.5-.673 1.5-1.5v-9c0-.827-.673-1.5-1.5-1.5zm-12 10.5v-9h12l.001 9H3.793z"
      ></path>
    </svg>
  );
}

export default GalleryIcon;
